import { Copy, PencilIcon, Trash2 } from 'lucide-react';
import { ColumnDef } from '@tanstack/react-table';
import { Link } from '@tanstack/react-router';
import { ChecklistQueryData } from '@area-restrita/api-client/model/checklistQueryData';

import { useAuthSessionStore } from '@/modules/authentication/stores/authSessionStore';
import { Button } from '@/components/ui/button';
import CloneCheckList from '../../components/CloneCheckList';
import SetDefaultChecklistAction from '../../components/SetDefaultChecklistAction';
import Dialog from '@/components/template/Dialog';

export const columns: ColumnDef<ChecklistQueryData>[] = [
  { header: 'Nome', accessorKey: 'name' },
  { header: 'Etapas', accessorKey: 'totalSteps' },
  {
    header: 'Ações',
    meta: { className: 'text-right' },
    cell: function ChecklistSettingsActionsCell({ row }) {
      const { checkAuthorization } = useAuthSessionStore();
      const canCreate = checkAuthorization(({ can }) =>
        can('create', 'checklists'),
      );
      const canViewDetails = checkAuthorization(({ can }) =>
        can('viewDetails', 'checklists'),
      );
      const canUpdate = checkAuthorization(({ can }) =>
        can('update', 'checklists'),
      );

      return (
        <div className="flex justify-end gap-3">
          <SetDefaultChecklistAction
            checklistId={row.original.id}
            checklistName={row.original.name}
            isDefault={row.original.isDefault}
            disabled={!canUpdate}
          />

          <Link
            to="/settings/hang-tag/check-list/$checklistId"
            params={{ checklistId: row.original.id }}
            disabled={!canViewDetails}
          >
            <Button variant="outline" size="icon-sm" disabled={!canViewDetails}>
              <PencilIcon className="h-4 w-4" />
            </Button>
          </Link>

          <Dialog
            title="Copiar Check List"
            description="Deseja copiar o check list?"
            trigger={
              <Button variant="outline" size="icon-sm" disabled={!canCreate}>
                <Copy className="h-4 w-4" />
              </Button>
            }
          >
            <CloneCheckList
              originalId={row.original.id}
              originalName={row.original.name}
            />
          </Dialog>

          <Button className="hidden" variant="destructive" size="icon-sm">
            <Trash2 className="h-4 w-4" />
          </Button>
        </div>
      );
    },
  },
];
